module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "logo-white.7089cb5d.png";